import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgView = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M38.858 42.505v38.95h38.951V42.504zm7.006 7.006h24.939V74.45h-24.94z" }), /* @__PURE__ */ _jsx("path", { d: "M18.885 23.555h35.814v15.046h-6.44v-8.605h-22.93v22.928h8.892v6.442H18.887V26.775z" })]
});
export default SvgView;
